/**
 * Seção "Tom de voz" em modo leitura (Brief 4 · Tela 2 · PR2).
 *
 * Renderiza as 3 dimensões reais do `voiceProfile` (formality/warmth/pace) como
 * VALOR textual em PT — NÃO como slider (o gabarito r5 usa TonSlider editável;
 * PR2 é leitura). O valor já vem em PT do serializer; só capitalizamos.
 */

import { VOICE_DIMENSION_LABELS, voiceValueLabel } from '../persona-labels';

import type { PersonaVoiceProfile } from '../types';

export function SectionVoiceRead({ voice }: { voice: PersonaVoiceProfile }): JSX.Element {
  const dimensions: (keyof PersonaVoiceProfile)[] = ['formality', 'warmth', 'pace'];

  return (
    <section className="pe-panel">
      <h2 className="pe-panel__title">Tom de voz</h2>
      <p className="pe-panel__subtitle">
        Como a IA assume a voz: formalidade, acolhimento e ritmo.
      </p>
      <div className="pe-grid-3">
        {dimensions.map((dim) => (
          <div className="pe-field" key={dim}>
            <span className="pe-field__label">{VOICE_DIMENSION_LABELS[dim]}</span>
            <p className="pe-read-value">{voiceValueLabel(voice[dim])}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
